import TemplateView from '../../../TemplateView'
import messageResource from '../../../messageResource'
import {GROUP_NEW_OR_NOT_KNOWN, ValidationErrors} from '../constants'
import AccountInformationSection from '../../../administration/userManagement/AccountInformationSection'
import {escapeHtmlSymbols, formatRawSecondsOffset, trim} from '../../../atUtils'
import {USERS_WITHOUT_GROUP_ID} from 'constants'
import TimeZonesSelector from '../../../controls/TimeZonesSelector'
import SimpleListMenuButton from '../../../SimpleListMenuButton'
import {isEnterPressed, isEscapePressed} from '../../../atBrowserUtils'
import _ from 'underscore'

export default class TimeZoneGroupRow extends TemplateView {
    constructor({
        showSaveButton = true,
        createNewGroup = () => {},
        updateRowDate = () => {},
        onGroupChanged = (id) => {},
        resetGroup = () => {},
        validateTimeZoneGroup = () => {},
    }) {
        super()

        this.params = {
            showSaveButton,
            createNewGroup,
            onGroupChanged,
            updateRowDate,
            resetGroup,
            validateTimeZoneGroup,
        }

        this.state = {
            groupId: USERS_WITHOUT_GROUP_ID,
            newGroupCreating: false,
            timeZoneGroups: [],
            timeZoneGroupsOffset: {},
            editable: false,
            errors: {},
        }

        this.cityData = null
        this.tzSelector = null
        this.citySelector = null

        this.confirmCreating = false
        this.enableCreateButton = false

        this.onAnyStatePropertyDeeplyChanged(['timeZoneGroups', 'groupId', 'timeZoneGroupsOffset', 'editable'], () => {
            this.$tzSelector.empty()
            this.$tzSelectorContainer.toggle(this.state.editable)
            this.$tzLabel.toggle(!this.state.editable)

            if (this.state.editable)
                this.selector = this._createTZSelector(this.state.timeZoneGroups, this.state.groupId, this.state.timeZoneGroupsOffset, this.$tzSelector)
        })

        this.onStatePropertyBecameValue('newGroupCreating', false, () => {
            if (this.citySelector)
                this.citySelector.resetToInit()

            this.$newGroupInput.val("")
        })

        this.onAnyStatePropertyChanged(['groupId', 'newGroupCreating'], () => {
            const id = this.state.groupId
            const creating = this.state.newGroupCreating

            if (creating && !this.citySelector) {
                // Late init city selector - only when need to show it.
                // Can't init it on page load, because Google Services might not be loaded yet,
                // and the city selector won't attempt to re-initialize when they are finally loaded.
                this.citySelector = this._createCitySelector()
            }

            this.$el.toggleClass('newGroupRow', creating)
            this.$newGroupSection.toggle(creating)
            this._setSelectedTimeZone(this.state.newGroupCreating ? GROUP_NEW_OR_NOT_KNOWN : this.state.groupId)

            //no need to disable the Create button in the newGroupCreating mode if the required fields for creating a new group are filled
            if (!id || creating && (!this.cityData || _.isEmpty(this.cityData.name) && !this.cityData.cityPlaceId)) {
                this._handleEnableCreateButton(false)

                //Set cityData to null for second group creation. Otherwise last created group data will be used silently
                //Exclude case, when we have DUPLICATE_TIME_ZONE_GROUP exception from server, and need to work with previous data
                if (!this.state.errors[ValidationErrors.DUPLICATE_TIME_ZONE_GROUP]) {
                    this.cityData = null
                }
                return
            }

            this.confirmCreating = false
        })

        this.onStatePropertyChanged('errors', errors => {
            const duplicate = !!errors[ValidationErrors.DUPLICATE_TIME_ZONE_GROUP]
            const emptyCity = !!errors[ValidationErrors.CITY_DATA_EMPTY]
            const emptyName = !!errors[ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY]

            this.$errorDuplicate.toggle(duplicate)
            this.$tzSelector.toggleClass('invalid', duplicate)

            this.$error_empty_new_time_zone.toggle(emptyCity || emptyName)

            this.$citySelector.toggleClass('invalid', emptyCity)
            this.$newGroupInput.toggleClass('invalid', emptyName || duplicate)

            const haveAnyError = duplicate || emptyCity || emptyName

            if (haveAnyError)
                this._handleEnableCreateButton(false)

            if (haveAnyError) {
                this.params.updateRowDate({
                    newGroupCreating: true,
                })
            } else if (this.confirmCreating) {
                if (!(haveAnyError)) {
                    this.params.updateRowDate({
                        newGroupCreating: false,
                    })
                }
            }
        })
    }

    templateHtml() {
        return "<div class='timeZoneGroupRow_userPanel userGroupData'>" +
               "  <div class='cellLabel'>" +
               "     <div class='label'>" +
               "       <%-label%>" +
               "     </div>:" +
               "  </div>" +
               "  <div class='timeZoneLabel'></div>" +
               "  <div class='timeZoneSelector selector'>" +
               "    <div class='timeZoneSelectorPlaceholder'/>" +
               "  </div>" +
               "  <div class='newGroupSection'>" +
               "    <div class='timeZoneCitySelector'>" +
               "      <div class='selector'>" +
               "    </div>" +
               "    <div class='newTimeZoneGroupName'>" +
               "       <input type='text' class='newTimeZoneGroupInput' name='newTimeZoneGroupName' maxlength='40'>" +
               "    </div>" +
               "    <div class='emptyError'><%-empty_new_time_zone_error%></div>" +
               "    <div class='duplicateError'><%-duplicate_error%></div>" +
               "    <div class='buttons'>" +
               "      <div class='saveButton'><%-save%></div>" +
               "      <div class='cancelButton'><%-cancel%></div>" +
               "    </div>" +
               "  </div>" +
               "</div>"
    }

    templateModel() {
        return {
            label: messageResource.getMessage('userlist.userdata.account_section.time_zone_group'),
            empty_new_time_zone_error: messageResource.getMessage('user.add_edit.error.fields_cannot_be_empty'),
            duplicate_error: messageResource.getMessage('user.add_edit.error.duplicate_time_zone_group_name'),
            save: messageResource.getMessage('common.create'),
            cancel: messageResource.getMessage('common.cancel'),
        }
    }


    afterRender() {
        this.$tzSelectorContainer = this.find(".selector")
        this.$tzSelector = this.find(".selector .timeZoneSelectorPlaceholder")
        this.$tzLabel = this.find(".timeZoneLabel")
        this.$citySelector = this.find(".timeZoneCitySelector .selector")
        this.$newGroupInput = this.find(".newTimeZoneGroupInput")
        this.$newGroupSection = this.find(".newGroupSection")

        this.$errorDuplicate = this.find(".newGroupSection  .duplicateError")
        this.$error_empty_new_time_zone = this.find(".newGroupSection .emptyError")

        if (this.params.showSaveButton) {
            this.$saveButton = this.find(".saveButton")
            this.$saveButton.click(() => {
                if (this.enableCreateButton) {
                    const name = trim(this.$newGroupInput.pVal())
                    this.confirmCreating = true
                    const newTZG = this._getNewTimeZoneGroup(this.cityData, name)
                    this.params.createNewGroup(newTZG)
                }
            })

            this.find(".cancelButton").click(() => {
                this.params.updateRowDate({
                    newGroupCreating: false,
                })

                this.params.resetGroup()
            })
        } else {
            this.find(".buttons").hide()
        }

        this.$newGroupInput.blur(() => {
            const name = trim(this.$newGroupInput.pVal())
            const newTZG = this._getNewTimeZoneGroup(this.cityData, name)
            if (this.params.showSaveButton) {
                this._handleEnableCreateButton(!!name)
                this.params.validateTimeZoneGroup(GROUP_NEW_OR_NOT_KNOWN, newTZG)
            }
            else {
                this.params.createNewGroup(newTZG)
            }
        })

        this.$newGroupInput.keydown(this._handleNewGroupInputKeyDown)

        this.$newGroupInput.attr("placeholder", messageResource.getMessage("user.add.js.time_zone_group_selector.new_time_zone_group_placeholder")).placeholder()

        this.renderInitialState()
    }

    _handleEnableCreateButton(enable) {
        if (this.params.showSaveButton) {
            this.enableCreateButton = enable
            this.$saveButton.toggleClass('disabled', !enable)
        }
    }

    _createTZSelector(timeZoneGroups, selectedTimeZoneGroupId, offsets, renderTo) {
        const newTimeZoneGroupGroup = this._createNewOrNotKnownItem()
        const listItems = timeZoneGroups ? timeZoneGroups : []

        let escapedListItems = listItems.map((item) => ({id: item.id, name: escapeHtmlSymbols(item.name), rawOffset: offsets[item.id]}))
        escapedListItems = [newTimeZoneGroupGroup].concat(escapedListItems)

        let selector = new SimpleListMenuButton({
            extraClass: 'components_userPanel_timeZoneGroupSelectorMenu',
            itemHtmlCallback: item => this._appendTimeZoneGroupRow(item),
            onSelect: (item) => {
                this.cityData = null
                this.params.updateRowDate({
                    newGroupCreating: item.id === GROUP_NEW_OR_NOT_KNOWN,
                    groupId: item.id,
                })
                if (item.id !== GROUP_NEW_OR_NOT_KNOWN) {
                    this.params.onGroupChanged(item.id)
                }
            },
            itemHeight: 30,
        }).init(renderTo)

        const selectedItem = escapedListItems.find(item => item.id === selectedTimeZoneGroupId)
        selector.setItems(escapedListItems, selectedItem || escapedListItems[0])

        return selector
    }

    _appendTimeZoneGroupRow(item) {
        return item.id === GROUP_NEW_OR_NOT_KNOWN ? `<span class="nameGroup">${item.name}</span>`
                                                  :`<span class="nameGroup">${item.name}</span> <span class="offset">
                                                    ${messageResource.getMessage("time_zones_selector.js.gmt",
                                                    [formatRawSecondsOffset(item.rawOffset)])}</span>`
    }

    _createCitySelector() {
        return new TimeZonesSelector().init(
            this.$citySelector,
            null,
            (data) => { this._cityChanged(data) },
            messageResource.getMessage('user.add.js.time_zone_group_selector.select_city_placeholder'),
            false,
            "userPopupSearch"
        )
    }

    _createNewOrNotKnownItem() {
        return {
            name: messageResource.getEscapedMessage("user.add.js.time_zone_group_selector.new_time_zone_group_item_title"),
            id: AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN,
            rawOffset: undefined,
        }
    }

    _cityChanged(data) {
        this.cityData = data
        const name = trim(this.$newGroupInput.pVal())
        if (!name) {
            this.$newGroupInput.pVal(data.name)
        }

        const newTZG = this._getNewTimeZoneGroup(data, !name ? data.name : name)

        if(!this.params.showSaveButton) {
            this.params.createNewGroup(newTZG)
        } else {
            this._handleEnableCreateButton(true)
            this.params.validateTimeZoneGroup(GROUP_NEW_OR_NOT_KNOWN, newTZG)
        }
    }

    _setSelectedTimeZone(id) {
        if (this.state.editable)
            this._setSelectorItem(id)
        else
            this._setSelectedTimeZoneLabel(id)
    }

    _setSelectorItem(id) {
        let item;
        if (id === GROUP_NEW_OR_NOT_KNOWN) {
            item = this._createNewOrNotKnownItem()
        } else {
            item = this.state.timeZoneGroups.find(item => item.id === id)
        }
        if (item) {
            this.selector.setSelectedItem({id: item.id, name: escapeHtmlSymbols(item.name), rawOffset: this.state.timeZoneGroupsOffset[item.id]})
        }
    }

    _setSelectedTimeZoneLabel(id) {
        const timeZone = this.state.timeZoneGroups.find(item => item.id === id)
        if (!!timeZone)
            this.$tzLabel.text(timeZone.name)
    }

    _getNewTimeZoneGroup(cityData, name) {
        return {
            id: GROUP_NEW_OR_NOT_KNOWN,
            name: name,
            cityPlaceId: cityData && cityData.placeId,
            cityName: cityData && cityData.name,
            timeZoneId: cityData && cityData.timeZoneId
        }
    };

    _handleNewGroupInputKeyDown = (e) => {
        if (isEscapePressed(e) || isEnterPressed(e)) {
            this.$newGroupInput.blur()
            e.stopPropagation()
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/components/TimeZoneGroupRow.js